// src/utils/locale.ts
/**
 * Centralized locale helpers.
 * - normalizeLocale: canonicalizes to "xx-yy" lowercase (e.g. "GB-en" -> "gb-en")
 * - normalizeCountry: returns the country portion (first segment), e.g. "gb"
 * - getIsoCode: converts a codename to "en-GB" style ISO (used for hreflang/schema)
 */

import { getMarket } from './markets';

export const normalizeLocale = (code?: string | null): string => {
    if (!code) return '';
    return code.toLowerCase();
};

export const normalizeCountry = (countryCode?: string | null): string => {
    const c = normalizeLocale(countryCode);
    return c.split('-')[0];
};

export function getIsoCode(languageCodename: string): string {
    if (!languageCodename) return 'en-US';
    const market = getMarket(languageCodename);
    if (market) return market.iso;

    const lowercaseCodename = languageCodename.toLowerCase();
    const splitCodename = lowercaseCodename.split('-');
    const language = splitCodename[splitCodename.length - 1];
    const location = splitCodename[0];

    // e.g. 'gb-en' -> 'en-GB'
    return language + '-' + location.toUpperCase();
}
